import React, {useEffect, useState} from 'react';
import BurgerButton from '../img/burger-menu.svg'
import CloseMenuCross from "../img/close-menu-cross.svg"
import {observer} from "mobx-react-lite";
import ModalDialog from "./ModalDialog";

const Header = ({isMenuOpen, setIsMenuOpen, store}) => {

    const [activeModal, setActiveModal] = useState("no")

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1001);
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 1001);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);



    return (
        <header className="header">

            <div className="header-left">
                <img
                    className={`burger-button ${isMenuOpen ? 'open' : ''}`}
                    src={isMenuOpen ? CloseMenuCross : BurgerButton}
                    width={"35px"}

                    alt={"Burger button"}
                    onClick={() => setIsMenuOpen(prev => !prev)}
                />
                <div className="title">{isMobile ? 'GT' : 'Gotham Trade'}</div>

            </div>

            <div className={"header-center"}>
            <h4 className={"header-page-title"}>{store.pageTitle}</h4>
            </div>

            <div className="header-right">
                <h1 className={"header-username"}>{store.user.login}</h1>
                <button
                    className={"gradient-dark-button logout-btn"}
                    onClick={() => {
                            setActiveModal("progress")
                            setTimeout(() => {
                                setActiveModal("active")
                            }, 100)

                    }}
                >{isMobile ? '🚪' : 'Exit'}
                </button>
            </div>
            <ModalDialog
                active={activeModal}
                setActive={setActiveModal}
                purpose={"choice"}
                message={"Вы действительно хотите выйти из аккаунта?"}
                action={() => store.logout(localStorage.getItem('browserId'))}
            />

        </header>

);
};

export default observer(Header);